import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/authentication/Register')));

const TermsAndConditions = Loadable(lazy(() => import('views/terms-and-conditions')));

const PaymentView = Loadable(lazy(() => import('views/payment/PaymentView')));
const PaymentResult = Loadable(lazy(() => import('views/payment/payment-result/index')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/login',
      element: <AuthLogin3 />
    },
    {
      path: '/register-trainer',
      element: <AuthRegister />
    },
    {
      path: '/payment',
      element: <PaymentView />
    },
    {
      path: 'payment-result',
      element: <PaymentResult />
    },
    {
      path: '/terms-and-conditions',
      element: <TermsAndConditions />
    }
  ]
};

export default AuthenticationRoutes;
